// AppContext.js
import React, {createContext, createRef} from 'react';
import { upsertOfflineMessage, getOfflineMessagesByTask ,getUnsentMessages, deleteOfflineMessage} from './IndexedDB/OfflineMessagesDB';
import { getPendingTasks, deletePendingTask } from './IndexedDB/PendingTasksDB';


import {useNavigate} from 'react-router-dom';

export const AppContext = createContext({});

const wssURL = process.env.REACT_APP_WSS_URL;
const secureURL = process.env.REACT_APP_SECURE_URL;
const secureKey = process.env.REACT_APP_UPLOAD_API_KEY;
const baseURL = process.env.REACT_APP_API_BASE_URL;

export class AppContextProvider extends React.Component {
    constructor(props) {
        super(props);
        this.navigateRef = createRef();
        this.state = {
            chatTask: null,
            ws: null,
            isWebSocketOpen: false,
            chatMessages: [],
            notificationData: [],
            members: JSON.parse(localStorage.getItem('members')) || [],
            staff: JSON.parse(localStorage.getItem('staff')) || [],
            hasChatLoaded: false,
            isOnline: false,
            items: [],
            doneItems: [],
            maxActiveTasks: 3,
            hasTasksLoaded: false,
            currentTab: "tasks",
            currentGeneralChatTab:null,
            scrollValue: 0,
            unreadMessageCount:{},
            showTaskAddedSuccess:false,
            chatHistoryError: null,
            queuedTasks:[],
            isWSLoading:true,
            syncStateWithServer: () => {
            },
            connectWebSocket: this.connectWebSocket,
            setStaffAndMembers: this.setStaffAndMembers,
            handleFileUpload: this.handleFileUpload,
            handleDeleteMessage: this.handleDeleteMessage,
            setChatTask: this.setChatTask,
            handleCloseChat: this.handleCloseChat,
            navigate: this.navigate,
            setSyncStateWithServer: this.setSyncStateWithServer,
            updateNotificationBadge: this.updateNotificationBadge,
            fetchChatHistory: this.fetchChatHistory,
            checkNetworkStatus: this.checkNetworkStatus,
            fetchTasks: this.fetchTasks,
            handleDeleteTask: this.handleDeleteTask,
            handleTogglePin: this.handleTogglePin,
            setMaxActiveTasks: this.setMaxActiveTasks,
            handleToggleHold: this.handleToggleHold,
            onDragEnd: this.onDragEnd,
            setCurrentTab: this.setCurrentTab,
            setScrollValue: this.setScrollValue,
            setUnreadCount:this.setUnreadCount,
            handleEditMessage:this.handleEditMessage,
            clearTaskBadges:this.clearTaskBadges,
            setActiveGeneralChatTab:this.setActiveGeneralChatTab,
            fetchSelection:this.fetchSelection,
            clearUnreadMessagesFromServer:this.clearUnreadMessagesFromServer,
            handleTaskAddedSucces:this.handleTaskAddedSucces,
            moveTaskUp:this.moveTaskUp,
            moveTaskDown:this.moveTaskDown,
            updateChatMessages:this.updateChatMessages,
            addQueuedTask:this.addQueuedTask,
            fetchMembers: this.fetchMembers,
            fetchStaff: this.fetchStaff,
            waitForWebSocketOpen: this.waitForWebSocketOpen,
            sendReadAcknowledgementType: this.sendReadAcknowledgementType,
        };
        this.sendingUnsentMessages = false;
        this.processingPendingTasks = false;
    }


    async componentDidMount() {
        const familyID = localStorage.getItem("familyID")
        if (familyID) {
            this.connectWebSocket(familyID);
        }
        this.checkNetworkStatus();
        const storedTasks = localStorage.getItem("tasks");
        window.appContext = this;
    
        window.appContext.clearPendingTasks = this.clearPendingTasks.bind(this);
        if (storedTasks) {
            try {
                const tasksObject = JSON.parse(storedTasks);
                this.setState({
                    items: tasksObject.items || [],
                    doneItems: tasksObject.doneItems || [],
                    hasTasksLoaded: true
                });
            } catch (error) {
                console.error("Error parsing tasks from localStorage:", error);
            }
        }

        await getPendingTasks().then((tasks) => {
            this.setState({ queuedTasks: tasks });
          });
    }

    addQueuedTask = (newTask) => {

        this.setState((prevState) => ({
          queuedTasks: [...prevState.queuedTasks, newTask]
        }));
      };
  

    navigate = (path) => {
        if (this.navigateRef.current) {
            this.navigateRef.current(path);
        } else {
            console.error('Navigate function not available');
        }
    };

    checkNetworkStatus = () => {
        this.handleNetworkStatus();
        this.networkCheckInterval = setInterval(this.handleNetworkStatus, 500);
    };

    waitForWebSocketOpen = async () => {
        while (!this.state.ws || this.state.ws.readyState !== WebSocket.OPEN) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      };
      
      

      sendUnsentMessages = async () => {
        if (this.sendingUnsentMessages) return;
        this.sendingUnsentMessages = true;
    
        try {
            await this.waitForWebSocketOpen();
    
            const unsentMessages = await getUnsentMessages();
            if (unsentMessages.length === 0) {
                this.sendingUnsentMessages = false;
                return;
            }
    
            for (const messageData of unsentMessages) {
                const { ID, unsentMessage, timestamp, ...cleanMessageData } = messageData;
    
                if (this.state.ws.readyState !== WebSocket.OPEN) {
                    throw new Error("WebSocket disconnected during sending unsent messages");
                }
    
                this.state.ws.send(JSON.stringify(cleanMessageData));
    
                // Wait briefly to allow message to flush
                await new Promise(resolve => setTimeout(resolve, 200));
    
                if (this.state.ws.readyState === WebSocket.OPEN) {
                    await deleteOfflineMessage(ID);
                    this.handleDeleteMessage(ID);
                } else {
                    throw new Error("WebSocket closed mid-operation");
                }
            }
    
            // Finalize
            this.sendingUnsentMessages = false;
    
        } catch (err) {
            console.error('Error sending unsent messages:', err);
            this.sendingUnsentMessages = false;
        }
    };
      

    clearPendingTasks = async () => {
        if (this.processingPendingTasks) return;
        this.processingPendingTasks = true;
        
        try {
          // Retrieve pending tasks from IndexedDB.
          const pendingTasks = await getPendingTasks();

          console.log("Pending tasks:", pendingTasks);
          
          if (pendingTasks.length > 0) {
            for (const task of pendingTasks) {
              try {
                const { taskText, Secret, familyID, memberID } = task.requestPayload;
                
                // Sync the offline task to your server.
                const response = await fetch(`${baseURL}/utils/addNewTask.php`, {
                  method: "POST",
                  body: JSON.stringify(task.requestPayload),
                });
                
                if (!response.ok) {
                  console.error("Error syncing offline task (response not OK):", task);
                  continue;
                }
                
                // On success, get the task ID from the response.
                const responseText = await response.text();
                let taskId;
                try {
                  const parsed = JSON.parse(responseText);
                  taskId = parsed.taskID;
                } catch {
                  taskId = responseText; // fallback if not JSON
                }
                
                // Prepare a message object to send via WebSocket.
                const messageData = {
                  type: 'app_chat_message',
                  member_id: memberID,
                  family_id: familyID,
                  task_id: taskId,
                  secret: Secret,
                  message: taskText,
                  uploaded_file: null,
                  file_metadata: null,
                };
      
                // Ensure the WebSocket is open.
                await this.waitForWebSocketOpen();
                this.state.ws.send(JSON.stringify(messageData));
                
                // Remove the pending task from IndexedDB.
                await deletePendingTask(task.id);

                this.setState((prevState) => ({
                    queuedTasks: prevState.queuedTasks.filter((t) => t.id !== task.id)
                  }));
                
              } catch (error) {
                console.error("Error syncing offline task:", error, task);
              }
            }
            console.log("Pending tasks cleared and synced.");
          }
        } finally {
          this.processingPendingTasks = false;
        }
      };
    
      
      
      
      handleNetworkStatus = async () => {
        const isOnline = navigator.onLine && this.state.isWebSocketOpen;
    
        this.setState((prevState) => {
            if (isOnline && !prevState.isOnline) {
                this.sendUnsentMessages();
                this.clearPendingTasks();
            }
            return { isOnline };
        });
    };

    handleTaskAddedSucces =(value)=>{
        this.setState({
            showTaskAddedSuccess:value
        },()=>{
            if (value === true){
                this.navigate('/#')
                this.setCurrentTab('tasks')
                setTimeout(() => {
                    this.setState({ showTaskAddedSuccess: false });
                }, 4000); 
              
            }
        })
    }

    setCurrentTab = (value) => {

        if(value!=='chat'){
        if (this.state.currentTab !== value) {
            this.setState({scrollValue: 0})
        }
        this.setState({currentTab: value})
    }
    }

    setActiveGeneralChatTab = (tab) => {
        return new Promise((resolve) => {
            this.setState({ currentGeneralChatTab: tab }, () => {
                resolve();
            });
        });
    };
    

    setScrollValue = (value) => {
        this.setState({scrollValue: value})
    }

    updateLocalStorageWithTasks = (stateKey, fetchedTasks) => {
        try {
          const storedTasks = localStorage.getItem("tasks");
          // If there’s no stored object, initialize with both keys
          let tasksObject = storedTasks ? JSON.parse(storedTasks) : { items: [], doneItems: [] };
          tasksObject[stateKey] = fetchedTasks;
          localStorage.setItem("tasks", JSON.stringify(tasksObject));
        } catch (error) {
          console.error("Error saving tasks to localStorage:", error);
        }
      };
      
      


    fetchTasks = async (tab) => {
        const familyID = localStorage.getItem("familyID")
        const memberID = localStorage.getItem("memberID")
        const done = tab === "done" ? 1 : 0;
        const stateKey = done ? 'doneItems' : 'items';

        const requestOptions = {
            method: "POST", headers: {
                "Content-type": "application/json; charset=UTF-8",
            }, body: JSON.stringify({
                familyID: familyID, function: "fetchClientTasks", done: done,
            }),
        };

        try {
            const response = await fetch(`${baseURL}/utils/fetchClientTasks.php`, requestOptions);
            const data = await response.json();
            const {records, txn} = data;

            const tasksNeedingSelection = records.filter((record) => {
                return record.fields["Research Status"] === "Done (Published)";
              });
          
              const selectionTaskIDs = tasksNeedingSelection.map((r) => r.id);
          
              let selectionDataMap = {};
              if (selectionTaskIDs.length > 0) {
                selectionDataMap = await this.fetchSelectionAll(selectionTaskIDs);
              }
            const fetchedTasks = (await Promise.all(records.map(async (record, index) => {
                if (record.fields["Secret Task"] && record.fields["Member"][0] !== memberID) {
                    return null;
                }

                const txnData = txn[record.id];
                if (txnData) {
                    record.fields["txnAmount"] = txnData[0];
                    record.fields["receipt"] = txnData[1];
                }

                if (record.fields["Research Status"] === "Done (Published)") {
                    const selectionData = selectionDataMap[record.id]; 
                    if (selectionData) {
                        record.recLink = selectionData.shortlink[0];
                        record.selectionDetail = selectionData.selectionDetail;
                    }                
                  }

                record.index = index;
                record.isPinned = (record.fields["Urgent Task"] && record.fields["Task - Status Text"][0] !== "On Hold");
                record.isHold = (record.fields["Task - Status Text"][0] === "On Hold");

                return record;
            }))).filter(record => record !== null);

            this.setState({ hasTasksLoaded: true, [stateKey]: fetchedTasks }, () => {
                this.updateLocalStorageWithTasks(stateKey, fetchedTasks);
              });


        } catch (error) {
            this.setState({hasTasksLoaded: true});
            console.error('Error:', error);
        }
    }

    fetchSelectionAll(taskIDs) {
        return new Promise((resolve, reject) => {
          const requestOptions = {
            method: "POST",
            headers: {
              "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify({
              function: "fetchSelectionAll",
              taskIDs: taskIDs,
            }),
          };
      
          fetch(`${baseURL}/utils/fetchClientTasks.php`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
          
              let shortlinkMap = {};
              if (data && Array.isArray(data.records)) {
                shortlinkMap = data.records.reduce((acc, selRec) => {
                  const taskRecordId = selRec.fields["Task Record Id"];
                  const shortlink = selRec.fields["Shortlink"];
                  const selectionDetail = selRec.fields["Selection Detail"];
                  if (taskRecordId && shortlink) {
                    acc[taskRecordId] = {
                        shortlink: shortlink,
                        selectionDetail: selectionDetail,
                      };
                  }
                  return acc;
                }, {});
              }
              resolve(shortlinkMap);
            })
            .catch((error) => {
              console.error("Error:", error);
              reject(error);
            });
        });
      }


    // used in fetchTaskByID for notifications
    fetchSelection(taskID) {
        return new Promise((resolve, reject) => {
            const requestOptions = {
                method: "POST", headers: {
                    "Content-type": "application/json; charset=UTF-8",
                }, body: JSON.stringify({
                    taskID: taskID, function: "fetchSelection",
                }),
            };

            fetch(`${baseURL}/utils/fetchClientTasks.php`, requestOptions)
                .then((response) => response.json())
                .then((data) => {
                    if (data && data.records && data.records.length > 0) {
                        const selection = data.records[0];
                        resolve(selection.fields["Shortlink"]);
                    } else {
                        resolve(null);
                    }
                }).catch((error) => {
                console.error('Error:', error);
                reject(error);
            });
        });
    }

    handleDeleteTask = (taskId) => {
        const updatedItems = this.state.items.filter((item) => item.id !== taskId);
        this.setState({items: updatedItems});
    };


    saveItemsOrder = (items) => {

        const familyID = localStorage.getItem('familyID');
        fetch(`${baseURL}/utils/saveOrder.php`, {
            method: "POST", body: JSON.stringify({familyID: familyID, items: items}),
        })
            .then((response) => response.text())
            .catch((error) => {
                console.error("There was an error saving the item order:", error);
            });
    };

    setMaxActiveTasks = (maxTasks) => {
        this.setState({maxActiveTasks: maxTasks})
    }


    handleTogglePin = (taskId, isUpgrading) => {
        const {items} = this.state;
        const pinnedItemsCount = items.filter(item => item.isPinned).length;
        const apiUrl = isUpgrading ? `${baseURL}/utils/upgradeClientTask.php` : `${baseURL}/utils/downgradeClientTask.php`;

        const newItems = items.map(item => {
            if (item.id === taskId) {
                if (item.isPinned || pinnedItemsCount < this.state.maxActiveTasks) {
                    item.isPinned = !item.isPinned;
                } else {
                    console.error("Max amount of items pinned.");
                }
            }
            return item;
        });

        const requestOptions = {
            method: "POST", headers: {
                "Content-type": "application/json; charset=UTF-8"
            }, body: JSON.stringify({taskId})
        };

        fetch(apiUrl, requestOptions)
            .then(response => {
                if (response.ok) {
                    this.setState({items: newItems});
                    this.saveItemsOrder(newItems);
                } else {
                    throw new Error(`Failed to ${isUpgrading ? 'upgrade' : 'downgrade'} task`);
                }
            })
            .catch(error => {
                console.error(error);
            });
    };


    handleToggleHold = (taskId, isHolding) => {
        const {items} = this.state;
        const apiUrl = `${baseURL}/utils/holdClientTask.php`;
        const newItems = items.map(item => {
            if (item.id === taskId) {
                item.isHold = !!isHolding;
            }
            return item;
        });

        const requestOptions = {
            method: "POST", headers: {
                "Content-type": "application/json; charset=UTF-8"
            }, body: JSON.stringify({taskId, isHolding})
        };

        fetch(apiUrl, requestOptions)
            .then(response => {
                if (response.ok) {
                    this.setState({items: newItems});
                } else {
                    throw new Error(`Failed to ${isHolding ? 'hold' : 'unhold'} task`);
                }
            })
            .then(() => {
                this.fetchTasks('Tasks').catch((error) => {
                    console.error("Error fetching tasks:", error);
                });
            })
            .catch(error => {
                console.error(error);
            });
    };

    onDragEnd = (result) => {
        if (!result.destination) return;

        const {source, destination} = result;
        const {items} = this.state;

        let newItems = [...items];
        let reorderedItems;
        const isHighPriorityDrag = source.droppableId === "HighPriority" && destination.droppableId === "HighPriority";
        const isNormalPriorityDrag = source.droppableId === "NormalPriority" && destination.droppableId === "NormalPriority";
        const isInfoPriorityDrag = source.droppableId === "InfoPriority" && destination.droppableId === "InfoPriority";

        if (isInfoPriorityDrag ||isHighPriorityDrag || isNormalPriorityDrag) {
            let filterCondition;
            if (isHighPriorityDrag) {
                filterCondition = item => item.isPinned;
            } else if (isNormalPriorityDrag) {
                filterCondition = item => !item.isHold 
                // filterCondition = item => !item.isPinned && item.fields['Task - Status Text'][0] !== 'Info Needed';
            } else if (isInfoPriorityDrag) {
                filterCondition = item => item.fields['Task - Status Text'][0] === 'Info Needed';
            }
            const filteredItems = items.filter(filterCondition);
            reorderedItems = this.reorder(filteredItems, source.index, destination.index);
            
            let j = 0;
            for (let i = 0; i < newItems.length; i++) {
                if (filterCondition(newItems[i])) {
                    newItems[i] = reorderedItems[j];
                    j++;
                }
            }
            newItems.forEach((item, idx) => {
                item.index = idx;
            });

            this.setState({items: newItems});
            this.saveItemsOrder(newItems);
        }
    };

    reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    moveTaskUp = (taskId) => {
        const { items } = this.state;
        const activeItems = items.filter(item => !item.isHold);
        const index = activeItems.findIndex(item => item.id === taskId);
    
        if (index > 0) {
            const currentItem = activeItems[index];
            const prevItem = activeItems[index - 1];
            const currentIndexInItems = items.findIndex(item => item.id === currentItem.id);
            const prevIndexInItems = items.findIndex(item => item.id === prevItem.id);
    
            const newItems = [...items];
            [newItems[currentIndexInItems], newItems[prevIndexInItems]] = [newItems[prevIndexInItems], newItems[currentIndexInItems]];
    
            // Update indices
            newItems.forEach((item, idx) => {
                item.index = idx;
            });
    
            this.setState({ items: newItems });
            this.saveItemsOrder(newItems);
        }
    };
    

    moveTaskDown = (taskId) => {
        const { items } = this.state;
        const activeItems = items.filter(item => !item.isHold);
        const index = activeItems.findIndex(item => item.id === taskId);
    
        if (index < activeItems.length - 1) {
            const currentItem = activeItems[index];
            const nextItem = activeItems[index + 1];
            const currentIndexInItems = items.findIndex(item => item.id === currentItem.id);
            const nextIndexInItems = items.findIndex(item => item.id === nextItem.id);
    
            const newItems = [...items];
            [newItems[currentIndexInItems], newItems[nextIndexInItems]] = [newItems[nextIndexInItems], newItems[currentIndexInItems]];
    
            // Update indices
            newItems.forEach((item, idx) => {
                item.index = idx;
            });
    
            this.setState({ items: newItems });
            this.saveItemsOrder(newItems);
        }
    };
    

   
    retryCount = 0;
    connectWebSocket = (familyID) => {

        if (this.state.ws === null || this.state.ws.readyState === WebSocket.CLOSED) {
            const socket = new WebSocket(`${wssURL}`);
            this.setState({  isWSLoading:true});
            const MAX_RETRIES = 25;
            const PING_INTERVAL = 30000; // Ping every 30 seconds to keep alive

            let pingInterval;

            const sendPing = () => {
                if (socket.readyState === WebSocket.OPEN) {
                    socket.send(JSON.stringify({type: 'ping'}));
                }
            };

            socket.addEventListener('open', () => {
                this.setState({isWSLoading:false, isWebSocketOpen: true, });

                const initMessage = {
                    type: 'init_connection', family_id: familyID,
                };
                socket.send(JSON.stringify(initMessage));
                this.fetchGeneralNotifications()
                pingInterval = setInterval(sendPing, PING_INTERVAL);
            });

            socket.addEventListener('error', console.error);

            socket.addEventListener('close', () => {
                this.setState({isWebSocketOpen: false});
                clearInterval(pingInterval);

                if (this.retryCount < MAX_RETRIES) {
                    console.error('Retrying connection to ws. ' + this.retryCount);
                    this.retryCount++;
                    setTimeout(() => this.connectWebSocket(familyID), 5000);
                } else {
                    console.error('Dead Connection');
                }
            });

            socket.addEventListener('message', (event) => {

                try {
                    const messageData = JSON.parse(event.data);
                    switch (messageData.type) {
                        case 'app_chat_message':
                        case 'chat_message':
                            this.handleChatMessage(messageData);
                            break;
                        case 'chat_history':
                            this.handleChatHistory(messageData);
                            break;
                        case 'updated_chat_history':
                            this.handleUpdatedChatHistory(messageData);
                            break;
                        case 'mark_as_read':
                            // Handle when ADMIN reads CLIENT messages
                            // Server broadcasts this after admin marks client messages as read
                            this.handleMarkClientMessageAsRead(messageData.message_ids);
                            break;
                        case 'admin_mark_as_read':
                            // Handle when CLIENT reads ADMIN messages
                            // Server broadcasts this after client marks admin messages as read
                            this.handleMarkAdminMessageAsRead(messageData.message_ids);
                            break;
                        case 'update_unread_count':
                            break;
                        case 'admin_update_unread_count':
                            break;
                        case 'notification':
                            this.handleNotification(messageData);
                            break;
                        case 'notification_history':
                            this.handleNotificationHistory(messageData)
                            break;
                        case 'notification_delete':
                            this.handleNotificationDelete(messageData.notification_id)
                            break;
                        case 'pong': // message types the client side can ignore
                        case 'admin_notification_mark_as_read':
                            break;
                        default:
                            console.error('Unhandled message type:', messageData.type);
                            break;
                    }
                } catch (error) {
                    console.error('Error parsing message:', error);
                }
            });

            this.setState({ws: socket});
        }
    };

    fetchGeneralNotifications = async () => {

        const socket = this.state.ws;
        const familyId = localStorage.getItem('familyID');
        const notificationRequest = {
            type: 'get_notification', family_id: familyId,
        };
        socket.send(JSON.stringify(notificationRequest));

    }

    handleChatMessage = (messageData) => {

        upsertOfflineMessage(messageData);
        const currentChat = this.determineCurrentChat();
        if (currentChat && messageData.task_id === currentChat.id) {
            this.updateChatMessages(messageData);
            if (messageData.user_id) {
                this.sendReadAcknowledgementType(messageData);
            }
        } else {
            this.state.syncStateWithServer(); // Fetch the unread counts
        }
    };

    determineCurrentChat = () => {
        return this.state.chatTask ? this.state.chatTask : null;
    };

    updateChatMessages = (messageData) => {
        this.setState(prevState => ({
            chatMessages: [...prevState.chatMessages, messageData]
        }));
    };

    handleNotification = (messageData) => {
        this.updateNotification(messageData);

    };
    handleNotificationHistory = (messageData) => {
        try {
            const incomingNotifications = messageData.notification.reverse();
            this.setState({
                notificationData: incomingNotifications,
            });
        } catch (error) {
            console.error("Error parsing chat history:", error);
        }

    };
    updateNotification = (messageData) => {
        this.setState(prevState => ({
            notificationData: [messageData, ...prevState.notificationData]
        }));
    };
    updateNotificationBadge = (updatedData) => {
        this.setState({notificationData: updatedData});
    };

    updateUnreadMessagesCount = (messageData) => {
        this.setState(prevState => {

            let updatedCount = {...prevState.unreadMessageCount, [messageData.task_id]: messageData.unread_count};

            return {unreadMessageCount: updatedCount};
        });
    };

    setUnreadCount =(count) =>{
        this.setState({unreadMessageCount:count})
    }

    clearTaskBadges = (taskID) => {
        return new Promise((resolve, reject) => {
            this.setState(prevState => {
                const updatedCount = {...prevState.unreadMessageCount};
                delete updatedCount[taskID];

                const { items, doneItems } = prevState;
                const allItems = [...(items || []), ...(doneItems || [])];
                // Calculate total unread messages after removing the count for the clicked task
                const totalUnreadMessages = Object.entries(updatedCount).reduce((acc, [id, count]) => {
                    if (
                        (allItems.some(item => item.id === id)) ||
                        id === 'General' ||
                        id.startsWith('mem_')
                    ) {
                        return acc + Number(count);
                    }
                    return acc;
                }, 0);

                this.clearAppBadge(totalUnreadMessages);

                // this.clearUnreadMessagesFromServer(taskID).catch((error) => {
                //     console.error("Error clearing messages from server:", error);
                // });

                return {unreadMessageCount: updatedCount};
            });
            resolve();
        });
    };

    clearUnreadMessagesFromServer = async (taskID) => {
        const familyId = localStorage.getItem('familyID');
        try {
            const response = await fetch(`${baseURL}/utils/pushNotifications.php?action=clearUnreadMessages`, {
                method: 'POST', headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }, body: `familyID=${familyId}&taskID=${taskID}&isAdmin=false`,
            });

            await response.json();
        } catch (error) {
            console.error('Error clearing unread messages:', error);
        }
    };

    clearOrphanedUnreadCounts = () => {
        const { items, doneItems, unreadMessageCount } = this.state;
        // Combine both active and done tasks
        const allTasks = [...(items || []), ...(doneItems || [])];
        const validTaskIDs = allTasks.map(task => task.id);
      
        const orphanedKeys = Object.keys(unreadMessageCount).filter(taskID =>
          !validTaskIDs.includes(taskID) &&
          taskID !== 'General' &&
          !taskID.startsWith('mem_')
        );
      
        if (orphanedKeys.length === 0) {
          return;
        }
    
        orphanedKeys.forEach(taskID => {
          this.clearUnreadMessagesFromServer(taskID)
            .catch(error => console.error(`Error clearing ${taskID}:`, error));
        });
      };
      
      
    clearAppBadge = (totalUnreadMessages) => {

        this.clearOrphanedUnreadCounts()
        if (!('setAppBadge' in navigator)) return;

        if (totalUnreadMessages > 0) {  
            navigator.setAppBadge(totalUnreadMessages).catch(error => {
                console.error("Failed to set app badge:", error);
            });  
        }  else if(totalUnreadMessages === 0){
            navigator.clearAppBadge()    
        } else {
            navigator.clearAppBadge().catch(error => {
                console.error("Failed to clear app badge:", error);
            });
        }
    };

    sendReadAcknowledgementType = (messagesOrIds, userType = 'client', familyId = null, taskId = null) => {
        let messageIds = [];

        if (Array.isArray(messagesOrIds)) {
            if (messagesOrIds.length > 0 && typeof messagesOrIds[0] === 'object') {
                messageIds = messagesOrIds.map(msg => msg.ID);
            } else {
                messageIds = messagesOrIds;
            }
        } else if (typeof messagesOrIds === 'object') {
            messageIds = [messagesOrIds.ID];
            familyId = familyId || messagesOrIds.family_id;
            taskId = taskId || messagesOrIds.task_id;
        } else {
            messageIds = [messagesOrIds];
        }

        messageIds = messageIds.filter(id => id != null);

        if (messageIds.length === 0) {
            return;
        }

        if (!familyId) {
            familyId = localStorage.getItem('familyID');
        }
        if (!taskId && this.state.chatTask) {
            taskId = this.state.chatTask.id;
        }

        const acknowledgement = {
            type: 'read_acknowledgement_type',
            family_id: familyId,
            task_id: taskId,
            message_ids: messageIds,
            user_type: userType,
        };

        if (this.state.ws && this.state.ws.readyState === WebSocket.OPEN) {
            this.state.ws.send(JSON.stringify(acknowledgement));
        } else {
            console.error('WebSocket is not open');
        }
    };

    sendReadAcknowledgement = (messageData) => {
        const acknowledgement = {
            type: 'read_acknowledgement',
            message_id: messageData.ID,
            family_id: messageData.family_id,
            task_id: messageData.task_id
        };
        this.state.ws.send(JSON.stringify(acknowledgement));
    };

    fetchChatHistory = (taskID) => {

        this.setState({ hasChatLoaded: false, chatHistoryError: null  });
        return new Promise(async (resolve, reject) => {
          try {

            // Only use IndexedDB if offline
            if (!this.state.isOnline) {
              const offlineMessages = await getOfflineMessagesByTask(taskID);
              if (offlineMessages.length > 0) {
                this.setState({ chatMessages: offlineMessages },()=>{
                   //wait for staff and members to be ready
                  const checkArrays = async (attempts = 0) => {
                      const staff = JSON.parse(localStorage.getItem('staff')) || [];
                      const members = JSON.parse(localStorage.getItem('members')) || [];
                      if (staff.length === 0 && members.length === 0) {
                          if (attempts < 100) {
                              await this.fetchStaff();
                              await this.fetchMembers();
                              setTimeout(() => checkArrays(attempts + 1), 50);
                          } else {
                              // Maximum attempts reached; allow chat to load.
                              this.setState({ hasChatLoaded: true }, () => { resolve(); });
                          }
                      } else {
                          this.setState({ hasChatLoaded: true }, () => { resolve(); });
                      }
                  };
                  checkArrays();
                });
              } else {
                this.setState({ hasChatLoaded: true, chatHistoryError: true });
                console.error("Failed to get chat history - offline with no cached messages");
              }
              resolve();
              return;
            }
          
            // Online: Always fetch from server (source of truth)
            if (this.state.isOnline) {
              try {
                const familyId = localStorage.getItem('familyID');

                // const requestData = { 
                //     familyID: familyId, taskID: taskID,
                // };
                // const response = await fetch(`${baseURL}/utils/fetchChatHistory.php?action=fetchChatHistory`, {
                const response = await fetch(`${baseURL}/utils/fetchChatMessages.php?action=fetchChat&familyID=${familyId}&taskID=${taskID}`, {
                //   method: 'POST',
                  method: 'GET',
                  headers: { 
                    // 'Content-Type': 'application/json', 
                    'Accept': 'application/json' 
                  },
                //   body: JSON.stringify(requestData)
                });
                if (!response.ok) {
                  throw new Error('Network response was not ok.');
                }
                const serverMessages = await response.json();
      
                // Convert datetime strings to Unix timestamps
                const convertedMessages = serverMessages.map(message => {
                  // Convert timestamp from "2025-12-18 11:39:05" to Unix timestamp
                  if (message.timestamp && typeof message.timestamp === 'string') {
                    message.timestamp = Math.floor(new Date(message.timestamp).getTime() / 1000);
                  }
                  // Convert timestamp_read if it exists
                  if (message.timestamp_read && typeof message.timestamp_read === 'string') {
                    message.timestamp_read = Math.floor(new Date(message.timestamp_read).getTime() / 1000);
                  }
                  // Convert admin_timestamp_read if it exists
                  if (message.admin_timestamp_read && typeof message.admin_timestamp_read === 'string') {
                    message.admin_timestamp_read = Math.floor(new Date(message.admin_timestamp_read).getTime() / 1000);
                  }
                  return message;
                });

                // Update IndexedDB with each converted message using upsert to avoid duplicates.
                convertedMessages.forEach((message) => {
                  upsertOfflineMessage(message);
                });
      
                // Update state with the converted messages.
                this.setState({ chatMessages: convertedMessages }, () => {
                  const checkArrays = async (attempts = 0) => {
                    const staff = JSON.parse(localStorage.getItem('staff')) || [];
                    const members = JSON.parse(localStorage.getItem('members')) || [];
                    if (staff.length === 0 && members.length === 0) {
                        if (attempts < 100) {
                            await this.fetchStaff();
                            await this.fetchMembers();
                            setTimeout(() => checkArrays(attempts + 1), 50);
                        } else {
                            this.setState({ hasChatLoaded: true }, () => { resolve(); });
                        }
                    } else {
                        this.setState({ hasChatLoaded: true }, () => { resolve(); });
                    }
                  };
                  checkArrays();
                });
              } catch (error) {
                console.error('Error fetching chat history from server:', error);
              }
            }
       
          } catch (error) {
            console.error('Error fetching chat history', error);
            reject(error);
          }
        });
      };
      
    

    handleChatHistory = (messageData) => {

        try {
            const incomingMessages = messageData.history;
            this.setState(prevState => ({
                chatMessages: [...incomingMessages, ...prevState.chatMessages],
            }));
        } catch (error) {
            console.error("Error parsing chat history:", error);
        }
    };


    handleUpdatedChatHistory = (messageData) => {
        try {
            const incomingMessages = messageData.history;
            this.setState({
                chatMessages: incomingMessages,
            });
        } catch (error) {
            console.error("Error parsing chat history:", error);
        }
        this.state.syncStateWithServer();
    };


    handleMarkClientMessageAsRead = (messageIDs) => {
        // Handle array of message IDs - when ADMIN reads CLIENT messages
        // Updates timestamp_read field (turns double tick green)
        if (!messageIDs || !Array.isArray(messageIDs) || messageIDs.length === 0) {
            return;
        }

        let chatMessages = [...this.state.chatMessages];
        let updatedCount = 0;
        const readTimestamp = new Date().toISOString();

        messageIDs.forEach(messageID => {
            if (!messageID) {
                return;
            }

            const messageIndex = chatMessages.findIndex(message => String(message.ID) === String(messageID));

            if (messageIndex !== -1) {
                chatMessages[messageIndex].timestamp_read = readTimestamp;
                
                upsertOfflineMessage(chatMessages[messageIndex])
                    .catch(err => console.error('Failed to update IndexedDB:', err));
                
                updatedCount++;
            } else {
                console.warn('Message ID not found in current chat:', messageID);
            }
        });

        if (updatedCount > 0) {
            this.setState({chatMessages: chatMessages});
        }
    };

    handleMarkAdminMessageAsRead = (messageIDs) => {
        // Handle array of message IDs - when CLIENT reads ADMIN messages
        // Updates admin_timestamp_read field
        if (!messageIDs || !Array.isArray(messageIDs) || messageIDs.length === 0) {
            return;
        }

        let chatMessages = [...this.state.chatMessages];
        let updatedCount = 0;
        const readTimestamp = new Date().toISOString();

        messageIDs.forEach(messageID => {
            if (!messageID) {
                return;
            }

            const messageIndex = chatMessages.findIndex(message => String(message.ID) === String(messageID));

            if (messageIndex !== -1) {
                chatMessages[messageIndex].admin_timestamp_read = readTimestamp;
                
                upsertOfflineMessage(chatMessages[messageIndex])
                    .catch(err => console.error('Failed to update IndexedDB:', err));
                
                updatedCount++;
            } else {
                console.warn('Message ID not found in current chat:', messageID);
            }
        });

        if (updatedCount > 0) {
            this.setState({chatMessages: chatMessages});
        }
    };

    handleCloseChat = async (keepChatTask = false) => {
        return new Promise((resolve) => {
            if (keepChatTask) {
                // this is used to clear chat messsage, used for switching between secret and general chat
                this.setState({ chatMessages: [] }, resolve);
            } else {
                // used to clear  the chat task as well for example moving out of the chat tab/ task chat
                this.setState({ chatTask: null, chatMessages: [] }, resolve);
            }
        });
    }    

    handleDeleteMessage = (messageId) => {
        const updatedMessages = this.state.chatMessages.filter((message) => message.ID !== messageId);
        this.setState({chatMessages: updatedMessages});
    };

    handleEditMessage = (messageId, newMessage) => {
        this.setState((prevState) => {
            const updatedMessages = prevState.chatMessages.map((message) => {
                if (message.ID === messageId) {
                    return { ...message, message: newMessage }; 
                }
                return message; 
            });
            return { chatMessages: updatedMessages }; 
        });
    };

    handleNotificationDelete = (notificationId) => {
        const updatedNotifications = this.state.notificationData.filter((notification) => notification.ID !== notificationId);
        this.setState({notificationData: updatedNotifications});

    };

    handleFileUpload = (file) => {

        return new Promise(async (resolve, reject) => {

            const familyId = localStorage.getItem('familyID');
            const formData = new FormData();
            formData.append('file', file);
            formData.append('familyid', familyId);

            try {

                const response = await fetch(`${secureURL}/fileupload/receiveFile.php`, {
                    method: 'POST', headers: {
                        'Authorization': `Bearer ${secureKey}`
                    }, body: formData,
                })

                const data = await response.json();

                if (data.success) {

                    const filePathBase64 = data.path;
                    const filePath = atob(filePathBase64);
                    const filePreviewForChat = `${secureURL}/fileupload/${filePath}`;

                    return resolve(filePreviewForChat);
                } else {
                    let error = data.message ?? "File upload failed. Please try again later";
                    reject(new Error(error));
                }
            } catch (error) {
                console.error(error);
                reject(error);
            }

        });
    }

   

    setChatTask = async (task) => {
        await new Promise((resolve) => {
            this.setState(
                { chatTask: task },
                () => {
                    this.retryCount = 0;
                    resolve();
                }
            );
        });
    }
    

    setSyncStateWithServer = (syncStateWithServer) => {

        this.setState({
            syncStateWithServer: syncStateWithServer,
        })

    }

     fetchMembers= async(familyID) => {
        const requestOptions = {
            method: "POST", headers: {
                "Content-type": "application/json; charset=UTF-8",
            }, body: JSON.stringify({
                familyID: familyID, function: 'fetchMemberID',
            }),
        };

        try {
            const response = await fetch(`${baseURL}/utils/fetchFamilyData.php`, requestOptions);
            const data = await response.json();

            this.setState({
             members: data
            })
            localStorage.setItem('members', JSON.stringify(data));
    
            return data;
        } catch (error) {
            console.error(error);
            return [];
        }
    }


       fetchStaff = async () => {
        const requestOptions = {
            method: "POST", headers: {
                "Content-type": "application/json; charset=UTF-8",
            }, body: JSON.stringify({
                function: 'fetchStaff',
            }),
        };

        try {
            const response = await fetch(`${baseURL}/utils/fetchFamilyData.php`, requestOptions);
            const data = await response.json();

            this.setState({
                staff: data
            })
            localStorage.setItem('staff', JSON.stringify(data));
    
            return data;
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    render() {
        return (<AppContext.Provider value={this.state}>
            {this.props.children}
        </AppContext.Provider>);
    }
}

export const AppContextProviderWithNavigate = (props) => {
    const navigate = useNavigate();
    return (<AppContextProvider {...props} ref={(instance) => {
        if (instance) {
            instance.navigateRef.current = navigate;
            instance.state.navigate = navigate;
        }
    }}/>);
};
